export const getWaiveEscrow = (hasWaivedEscrow) => {
  if(hasWaivedEscrow === 'Yes') {
    return 'true';
  }
  return 'false';
}
